import React from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import { NativeBaseProvider } from "native-base";
import { useFonts } from "expo-font";
import { Qrcode } from "./src/screens/Login/Qrcode";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { apolloClient } from "./graphql/client";
import { ApolloProvider } from "@apollo/client";
import { linking } from "./src/navigation/navigation";
import { Meet } from "./src/screens/Meet";
const Stack = createNativeStackNavigator();

const uri = "Test Site";
console.log(uri);

export default function App() {
  const [fontLoadTimedOut, setFontLoadTimedOut] = React.useState(false);
  const [fontsLoaded, fontError] = useFonts({
    "NotoSansTC-Regular": require("./assets/fonts/Noto_Sans_TC/NotoSansTC-Regular.woff"),
    "NotoSansTC-Medium": require("./assets/fonts/Noto_Sans_TC/NotoSansTC-Medium.woff"),
    "NotoSansTC-Bold": require("./assets/fonts/Noto_Sans_TC/NotoSansTC-Bold.woff"),
    "NotoSansKR-Medium": require("./assets/fonts/Noto_Sans_KR/NotoSansKR-Medium.woff"),
    "NotoSansJP-Regular": require("./assets/fonts/Noto_Sans_JP/NotoSansJP-Regular.woff2"),
    "NotoSansJP-Medium": require("./assets/fonts/Noto_Sans_JP/NotoSansJP-Medium.woff2"),
    "Lexend-Regular": require("./assets/fonts/Lexend/Lexend-Regular.woff"),
    "Lexend-Medium": require("./assets/fonts/Lexend/Lexend-Medium.woff"),
    "Lexend-SemiBold": require("./assets/fonts/Lexend/Lexend-SemiBold.woff"),
    "Roboto-Regular": require("./assets/fonts/Roboto/Roboto-Regular.woff"),
  });

  React.useEffect(() => {
    if (fontError) {
      console.error("Failed to load custom fonts. Using system fonts instead.", fontError);
    }
  }, [fontError]);

  React.useEffect(() => {
    if (fontsLoaded || fontError) {
      return;
    }

    const timeoutId = setTimeout(() => {
      console.warn("Custom font loading timed out. Using system fonts instead.");
      setFontLoadTimedOut(true);
    }, 10000);

    return () => clearTimeout(timeoutId);
  }, [fontsLoaded, fontError]);

  if (!fontsLoaded && !fontError && !fontLoadTimedOut) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#F48120" />
        <Text style={styles.loadingText}>Loading...</Text>
      </View>
    );
  }

  return (
    <ApolloProvider client={apolloClient}>
      <NativeBaseProvider>
        <NavigationContainer linking={linking}>
          <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="Qrcode" component={Qrcode} />
            {/*<Stack.Screen*/}
            {/*    name="CopyModal"*/}
            {/*    component={() => <CopyModal copyName={'test'} />}*/}
            {/*/>*/}
            <Stack.Screen name="Meet" component={Meet} />
          </Stack.Navigator>
        </NavigationContainer>
      </NativeBaseProvider>
    </ApolloProvider>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FEF2E9",
  },
  loadingText: {
    marginTop: 12,
    color: "#F48120",
    fontFamily: "Lexend-Medium",
    fontSize: 16,
  },
});
